import React, { useState, useRef, useEffect } from "react";
import SC from "./style";
import { Radio, FormControlLabel } from "@mui/material";

const RevisionFilterDropdown = ({
  label = "Revision",
  value = "",
  onUpdate,
  radioOptions = [],
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState(value);
  const dropdownRef = useRef();

  // Sync selected option with parent value
  useEffect(() => {
    setSelectedOption(value || "");
  }, [value]);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleSelect = (optionKey) => {
    setSelectedOption(optionKey);
    onUpdate(optionKey); // send selected key/value to parent
    setIsOpen(false);
  };

  return (
    <SC.DropdownContainer ref={dropdownRef}>
      <SC.DropdownButton
        isOpen={isOpen}
        isActive={!!selectedOption}
        onClick={() => setIsOpen(!isOpen)}
      >
        {selectedOption
          ? `${label}: ${
              radioOptions.find((o) => o.key === selectedOption)?.label
            }`
          : label}
        <SC.ChevronIcon size={14} isOpen={isOpen} isActive={!!selectedOption} />
      </SC.DropdownButton>

      <SC.DropdownMenu isOpen={isOpen}>
        {radioOptions.map(({ key, label }) => (
          <div key={key} style={{ padding: "3px" }}>
            <FormControlLabel
              value={key}
              control={
                <Radio
                  checked={selectedOption === key}
                  onChange={() => handleSelect(key)}
                  sx={{
                    "& .MuiSvgIcon-root": { fontSize: 20 },
                    "&.Mui-checked": { color: "#EC810B" },
                  }}
                />
              }
              label={<span style={{ fontSize: "14px" }}>{label}</span>}
            />
          </div>
        ))}

        {/* Footer */}
        <SC.DropdownFooter>
          <SC.ClearAllButton
            onClick={() => {
              setSelectedOption("");
              onUpdate("");
              setIsOpen(false);
            }}
          >
            Clear
          </SC.ClearAllButton>
        </SC.DropdownFooter>
      </SC.DropdownMenu>
    </SC.DropdownContainer>
  );
};

export default RevisionFilterDropdown;
